@if (task.Description) {
    <p>{{ task.Description }}</p>
}
<ul class="npc-state-requirements">
    @for (requirement of task.RequirementsCompleted; track requirement) {
        <li [ngClass]="requirement.Completed ? 'text-success' : 'text-danger'">
            {{ requirement.Completed ? '✓' : '✗' }} {{ requirement.Description }}
        </li>
    }
</ul>
